import { Pipe, PipeTransform } from '@angular/core';
import { OrderData } from '@zero/shared/util-models';

@Pipe({
  name: 'orderStopLimit',
  standalone: true,
})
export class OrderStopLimitPipe implements PipeTransform {
  public transform(order: OrderData): number | undefined {
    if (order) {
      if (order.execType === 'stoplimit') {
        return order.limitPrice;
      } else {
        return undefined;
      }
    }
    return undefined;
  }
}
